"use strict";

var ButtonGroup = require("app/shared/components/ButtonGroup/button-group");
var Button = require("app/shared/components/Button/button");
var Icon = require("app/shared/components/Icon/icon");

var cx = require("classnames");

var DealsVisualizationButtons = React.createClass({
  propTypes: {
    selectedIndex: React.PropTypes.number.isRequired
  },
  render: function(){
    return (
      <ButtonGroup className="pull-right">
        <Button href={{url: "/sistema/negocios", name: "_self"}} type="filter"
                className={this.props.selectedIndex === 1 ? "selected" : ""}>
          <Icon custom icon="list"></Icon>
          <span className="hidden-md hidden-sm hidden-xs">Listagem</span>
        </Button>
        <Button id="funilVN" href={{url: "/sistema/negocios/funil.php", name: "_self"}} type="filter"
                className={this.props.selectedIndex === 2 ? "selected" : ""}>
          <Icon custom icon="pipeline"></Icon>
          <span className="hidden-md hidden-sm hidden-xs">Funil</span>
        </Button>
        <Button href={{url: "/sistema/negocios/mapa.php", name: "_self"}} type="filter"
                className={this.props.selectedIndex === 3 ? "selected" : ""}>
          <Icon custom icon="sales-map"></Icon>
          <span className="hidden-md hidden-sm hidden-xs">Mapa</span>
        </Button>
      </ButtonGroup>
    );
  }
});

module.exports = DealsVisualizationButtons;



// WEBPACK FOOTER //
// ./app/shared/components/List/deals-visualization-buttons.jsx